const HIGH_VALUE_THRESHOLD_EUR = 1_000;

// ECB reference rates from 2026-07-31. These only select the storefront CTA;
// checkout and customer charging continue to use backend prices.
const EUR_REFERENCE_RATES = {
  EUR: 1,
  CZK: 24.212,
  PLN: 4.3135,
  HUF: 364.25,
} as const;

type SupportedCurrency = keyof typeof EUR_REFERENCE_RATES;

const CURRENCY_BY_LABEL: Record<string, SupportedCurrency> = {
  '€': 'EUR',
  EUR: 'EUR',
  KČ: 'CZK',
  KC: 'CZK',
  CZK: 'CZK',
  ZŁ: 'PLN',
  ZL: 'PLN',
  PLN: 'PLN',
  FT: 'HUF',
  HUF: 'HUF',
};

function resolveCurrency(currency: string): SupportedCurrency | null {
  return CURRENCY_BY_LABEL[currency.trim().toLocaleUpperCase()] ?? null;
}

export function getHighValueThreshold(currency: string): number | null {
  const currencyCode = resolveCurrency(currency);

  if (!currencyCode) return null;

  return HIGH_VALUE_THRESHOLD_EUR * EUR_REFERENCE_RATES[currencyCode];
}

export function isHighValueProductPrice(
  priceWithVat: number | null | undefined,
  currency: string,
): boolean {
  const threshold = getHighValueThreshold(currency);

  return threshold !== null && typeof priceWithVat === 'number' && priceWithVat > threshold;
}
